export const formatPhoneNumberWithExtention = (
  number: string,
  ext?: string
): string => {
  // Check if the number has the expected length
  if (number?.length !== 10) {
    return number;
  }

  // Separate the number into its parts
  const areaCode = number.slice(0, 3);
  const prefix = number.slice(3, 6);
  const remainingNumber = number.slice(6);

  // Format the number in the desired format
  return `+${ext ?? "1"} (${areaCode})-${prefix}-${remainingNumber}`;
};
